import { IOwnerKenloEndpoints } from "../types/ownerDashboard.types";

export const DEFAULT_OWNER_DASHBOARD_ENDPOINTS: Required<IOwnerKenloEndpoints> = {
  kenlo_payments: "/api/client/owner/dashboard/kenlo-payments",
  market_indices: "/api/client/owner/dashboard/market-indices",
  property_returns: "/api/client/owner/dashboard/property-returns",
  financing_insights: "/api/client/owner/dashboard/financing-insights",
  property_analytics: "/api/client/owner/dashboard/property-analytics",
  offers: "/api/client/owner/dashboard/offers",
  pending_signatures: "/api/client/owner/dashboard/pending-signatures",
};

export function resolveOwnerDashboardEndpoint(
  endpoints: IOwnerKenloEndpoints | undefined,
  key: keyof IOwnerKenloEndpoints
): string {
  const configuredEndpoint = endpoints?.[key];

  if (configuredEndpoint) {
    return configuredEndpoint.startsWith("/")
      ? configuredEndpoint
      : `/${configuredEndpoint}`;
  }

  return DEFAULT_OWNER_DASHBOARD_ENDPOINTS[key];
}
